package com.eladfinish.bible.contest.screens.settings.ui.screens

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.navigation.NavController
import com.eladfinish.bible.contest.common.settings.KeyValueSettings
import com.eladfinish.bible.contest.screens.settings.SettingsAction
import com.eladfinish.bible.contest.screens.settings.SettingsStore
import com.eladfinish.bible.contest.screens.settings.ui.components.ComponentNavigationDestination
import com.eladfinish.bible.contest.screens.settings.ui.components.model.SubSettingsComponentType
import com.eladfinish.bible.contest.screens.settings.ui.dialogs.SettingsDialogs
import com.eladfinish.bible.contest.ui.components.mouseVerticalScrollbar
import com.eladfinish.bible.contest.ui.extensions.navigationBarContentPadding
import com.eladfinish.bible.contest.ui.layout.readableWidth
import kotlinx.coroutines.flow.Flow
import org.koin.compose.viewmodel.koinViewModel

@Composable
internal fun SubSettingsScreens(
    store: SettingsStore = koinViewModel(),
    settings: KeyValueSettings,
    component: ComponentNavigationDestination,
    navController: NavController,
    getBooleanFlow: (String, Boolean) -> Flow<Boolean>,
) {
    val state by store.observeState().collectAsState()

    val listState = rememberLazyListState()

    LazyColumn(
        state = listState,
        modifier = Modifier
            .fillMaxSize()
            .readableWidth()
            .mouseVerticalScrollbar(listState),
        contentPadding = navigationBarContentPadding(horizontal = 16.dp, top = 16.dp, bottom = 16.dp),
    ) {
        item {
            when (component.type) {
                SubSettingsComponentType.RANDOM_VERSE_SETTINGS ->
                    RandomVerseSettingsScreen(
                        navController = navController,
                        settings = settings,
                        getBooleanFlow = getBooleanFlow,
                        showRandomApproachExplanation = {
                            store.dispatch(SettingsAction.RandomApproachChanged)
                        },
                    )

                SubSettingsComponentType.CHAPTER_COMPLETE_SETTINGS ->
                    ChapterCompleteSettingsScreen(
                        settings = settings,
                    )

                SubSettingsComponentType.PAIR_MATCHING_SETTINGS -> {
                    PairMatchingSettingsScreen(
                        settings = settings,
                    )
                }

                SubSettingsComponentType.OPEN_QUESTIONS_SETTINGS -> {
                    OpenQuestionsSettingsScreen(
                        settings = settings,
                    )
                }

                SubSettingsComponentType.AMERICAN_QUESTIONS_SETTINGS -> {
                    AmericanQuestionsSettingsScreen(
                        navController = navController,
                        settings = settings,
                    )
                }
            }
        }
    }

    SettingsDialogs(
        dialogState = state.dialogState,
        onAction = store::dispatch,
    )
}
